import { ConfirmExternalFlightBookingDetailsState } from './confirmExternalFlightBookingDetails.types'

const initialState: ConfirmExternalFlightBookingDetailsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
